import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import MapView from './MapView';

import './App.css';

export default function App() {

  const apiKey = process.env.REACT_APP_API_KEY;

  return (
      <Router>
        <Routes>
          <Route
              path="/:id"
              element={
                <MapView
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=3.exp&libraries=geometry,drawing,places`}
                    loadingElement={<div style={{height: `100%`}}/>}
                    containerElement={<div style={{height: `100vh`}}/>}
                    mapElement={<div style={{height: `100%`}}/>}
                />
              }
          />
        </Routes>
      </Router>
  );
}
